var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-table-with-crud-actions',{attrs:{"id":"trax-account-basic-client","titles":_vm.titles,"props":_vm.props,"endpoint":_vm.endpoint,"bus":_vm.bus}})
}
var staticRenderFns = []

export { render, staticRenderFns }